import Drip from "../../apis/Drip";
import router from "../../router";

const state = {
    notifications: [],
    errorTrigger: ""
};

const actions = {
    getTriggers({ commit }, params) {
        return new Promise((resolve, reject) => {
            Drip.get("trigger", params)
                .then((response) => {
                    resolve(response);
                    commit("GET_TRIGGER", response.data.data);
                })
                .catch((err) => {
                    reject(err);
                    if (err.response) {
                        commit("DETECT_ERROR", err.response);
                    }
                })
        })
    },
    updateTrigger({ commit }, data) {
        return new Promise((resolve, reject) => {
            Drip.update(data.id, data.json)
                .then((response) => {
                    resolve(response);
                    //commit("UPDATE_TRIGGER", { id: id, response: response });
                })
                .catch((err) => {
                    reject(err);
                    if (err.response) {
                        commit("DETECT_ERROR", err.response);
                    }
                })
        })
    },
    storeTrigger({ commit }, json) {
        return new Promise((resolve, reject) => {
            Drip.store(json)
                .then((response) => {
                    resolve(response);
                    //commit("STORE_TRIGGER", response.data.data);
                })
                .catch((err) => {
                    reject(err);
                    if (err.response) {
                        commit("DETECT_ERROR", err.response);
                    }
                })
        })
    },
    deleteTrigger({ commit }, id) {
        return new Promise((resolve, reject) => {
            Drip.deleteInitial(id)
                .then((response) => {
                    resolve(response)
                    commit("DELETE_TRIGGER", id);
                })
                .catch((err) => {
                    reject(err);
                    if (err.response) {
                        commit("DETECT_ERROR", err.response);
                    }
                })
        })
    },
    clearTriggersArray({ commit }) {
        commit("CLEAR_TRIGGERS_ARRAY");
    }
};

const mutations = {
    GET_TRIGGER(state, notifications) {
        state.notifications = notifications;
    },
    // UPDATE_TRIGGER(state, data) {
    //     let indx = state.notifications.findIndex((el) => el.id === data.id);
    //     state.notifications[indx] = data.response;
    // },
    STORE_TRIGGER(state, json) {
        state.notifications[0].push(json);
    },
    DELETE_TRIGGER(state, id) {
        let indx = state.notifications.findIndex((el) => el.id === id);
        state.notifications.splice(indx, 1);
    },
    CLEAR_TRIGGERS_ARRAY(state) {
        state.notifications = [];
    },
    DETECT_ERROR(state, error) {
        if (error.status == 401 || error.status == 419) {
            User.logout().then(() => {
                localStorage.removeItem("auth");
                router.push({ name: "Login", path: router.currentRoute.path });
            })
        } else if (error.data.message !== undefined && router.currentRoute.name !== "NewWebsite") {
            state.errorTrigger = error.data.message;
        }
        setTimeout(() => {
            state.errorTrigger = ""
        }, 1000)
    },
};

export default {
    state,
    actions,
    mutations,
};
